import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PRE_AUTH_PATH_KEY } from "@@common";

const PathRestoration: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if there's a stored path to restore
    const storedPath = sessionStorage.getItem(PRE_AUTH_PATH_KEY);

    if (storedPath && storedPath !== location.pathname) {
      // Clear the stored path
      sessionStorage.removeItem(PRE_AUTH_PATH_KEY);

      // Navigate to the stored path
      navigate(storedPath, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default PathRestoration;
